import { useState, useEffect } from 'react';

/**
 * Cookie Consent Banner Component
 * GDPR-compliant cookie consent for analytics tracking
 */
function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a consent choice
    const consent = localStorage.getItem('ga_cookie_consent');
    if (consent === null) {
      // Show banner after a short delay
      setTimeout(() => {
        setShowBanner(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('ga_cookie_consent', 'accepted');

    // Initialize GA4 now that user has consented (strict GDPR mode)
    if (window.gtag && window.GA_TRACKING_ID) {
      // Set consent to granted
      window.gtag('consent', 'default', {
        'analytics_storage': 'granted'
      });
      // Initialize GA4
      window.gtag('js', new Date());
      window.gtag('config', window.GA_TRACKING_ID, {
        'anonymize_ip': true
      });
    }

    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('ga_cookie_consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div
      className="cookie-consent-banner"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#1a1a1a',
        color: 'white',
        padding: '20px',
        zIndex: 9999,
        boxShadow: '0 -2px 10px rgba(0,0,0,0.3)'
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-8 mb-3 mb-md-0">
            <p className="mb-0">
              <strong>Cookie Notice</strong>
              <br />
              We use cookies and analytics to improve your experience on our site.
              By clicking "Accept", you consent to our use of cookies and analytics tracking.
              <a
                href="/privacy-policy"
                style={{ color: '#00bcd4', marginLeft: '10px' }}
              >
                Learn more
              </a>
            </p>
          </div>
          <div className="col-md-4 text-md-right">
            <button
              onClick={handleDecline}
              className="btn btn-outline-light mr-2"
              style={{ minWidth: '100px' }}
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="btn btn-primary"
              style={{ minWidth: '100px', backgroundColor: '#00bcd4', borderColor: '#00bcd4' }}
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
